// React imports
import React, { useEffect, useMemo, useState } from 'react';

// Components
import ScrollToTop from '../components/ScrollToTop.tsx';
import Container from '../components/Container.tsx';
import ModalContent from '../components/ModalContent.tsx';

// Contexte
import { useInTheGame } from '../utils/InTheGameContexte.tsx';

// Librairies
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

// Data
import plusInfos from '../data/plusInfos.ts';

function PlusInfos() {
    // Toggle Game pour afficher le logo
    const { toggleGame } = useInTheGame();
    useEffect(() => {
        toggleGame(true);
    }, [toggleGame]);

    // Hauteurs des espacements entre les blocs avec les sources
    const spacingHeights = ['18.5rem', '24rem', '22rem', '15rem'];

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [linkHref, setLinkHref] = useState('');

    // Fonction pour gérer la confirmation avant de quitter la page
    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Empêcher la navigation par défaut
        e.preventDefault();
        setLinkHref(e.currentTarget.href);
        setIsModalOpen(true);
    };

    // Contenu des informations supplémentaires
    const infosContent = useMemo(() => {
        return plusInfos.map((reference, index) => {
            // console.log(reference);
            spacingHeights[index];
            let i = 0;
            i = i + 1;
            console.log(`{${i}--article-info-compl}`);

            return (
                <article key={`{${i}--article-info-compl}`}>
                    <h2
                        id={`plusInfosTitle-${index}`}
                        className={`text-special plusInfos__subtitle plusInfos__subtitle--${reference.color}`}
                    >
                        {reference.title}
                    </h2>
                    <h3 className='plusInfos__question'>{reference.question}</h3>
                    <p className='plusInfos__response'>
                        Réponse -{' '}
                        <ReactMarkdown
                            components={{
                                p: ({ ...props }) => <span {...props} />,
                            }}
                            rehypePlugins={[rehypeRaw]}
                        >
                            {reference.response}
                        </ReactMarkdown>
                    </p>
                    {reference.text &&
                        reference.text.map((text, index) => (
                            <>
                                {reference.subtitles && (
                                    <ReactMarkdown
                                        key={`texteReferenceSubtitle${reference.title}-${index}`}
                                        components={{
                                            p: ({ ...props }) => <h4 {...props} />,
                                        }}
                                        rehypePlugins={[rehypeRaw]}
                                        className={'plusInfos__text'}
                                    >
                                        {reference.subtitles[index]}
                                    </ReactMarkdown>
                                )}
                                <ReactMarkdown
                                    key={`texteReference${reference.title}-${index}`}
                                    components={{
                                        p: ({ ...props }) => <p {...props} />,
                                    }}
                                    rehypePlugins={[rehypeRaw]}
                                    className={'plusInfos__text'}
                                >
                                    {text}
                                </ReactMarkdown>
                            </>
                        ))}
                    <div>
                        <div
                            id={`sources-${index}`}
                            className={`plusInfos__sources plusInfos__sources--${reference.color}`}
                        >
                            <p
                                className='text-page-semib'
                                style={{ fontStyle: 'italic' }}
                            >
                                SOURCES
                            </p>

                            {reference.sources &&
                                reference.sources.map((text, index) => (
                                    <ReactMarkdown
                                        key={`sourceReference${reference.title}-${index}`}
                                        components={{
                                            p: ({ ...props }) => <p {...props} />,

                                            a: ({ ...props }) => (
                                                <a
                                                    {...props}
                                                    className='custom-link'
                                                    onClick={handleLinkClick}
                                                />
                                            ),
                                        }}
                                        rehypePlugins={[rehypeRaw]}
                                    >
                                        {text}
                                    </ReactMarkdown>
                                ))}
                        </div>
                        <div style={{ height: spacingHeights[index] }}></div>
                    </div>
                </article>
            );
        });
    }, [plusInfos]);

    // Scroll vers la section ciblée
    const handleScrollToSection = (sectionId: string) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <>
            <ModalContent
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                linkHref={linkHref}
            />
            <Container color='white'>
                <section
                    className='plusInfos'
                    id='plusInfosTitle'
                >
                    <h1 className='text-special text-special--red'>Pour aller plus loin</h1>
                    <ul className='text-page-light reglesContent__link'>
                        {plusInfos.map((reference, index) => {
                            return (
                                <li
                                    key={`sectionCible-${reference.title}${index}`}
                                    className='text-page-semib text-page-semib--blackSmall'
                                    onClick={() => handleScrollToSection(`plusInfosTitle-${index}`)}
                                >
                                    {reference.question}
                                </li>
                            );
                        })}
                    </ul>
                    {infosContent}
                    <div
                        style={{
                            marginInline: 'auto',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: '2rem',
                        }}
                    >
                        <ScrollToTop sectionId='plusInfosTitle' />
                    </div>
                </section>
            </Container>
        </>
    );
}

export default PlusInfos;
